import React from "react";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "../../form/Input";
import TotalReceivingUnits from "src/components/capture/ReceivingWizard/Shipment/TotalReceivingUnits/TotalReceivingUnits";
import useQueryParams from "src/hooks/useQueryParams";

export default function ItemShipmentInfoFields({ project, shipmentItem }) {
  const { values } = useFormikContext();
  const params = useQueryParams();
  const navigate = useNavigate();

  if (!shipmentItem || shipmentItem.quantity === 0 || !values.description) {
    return null;
  }

  const handleOpenInventoryPlacement = () => {
    params.set("inventoryPlacement", "true");
    navigate({ search: params.toString() });
  };

  return (
    <Grid size={12}>
      <Card sx={{ overflow: "visible" }}>
        <CardContent>
          <Box mt={-1} mb={1}>
            <Typography fontWeight={500} fontSize={18}>
              Item Shipment Info
            </Typography>
          </Box>
          <Grid container spacing={1}>
            <Grid size={12}>
              <TextField
                fullWidth
                size="small"
                type="number"
                name="shipmentItemQuantity"
                label="Quantity Received in This Shipment"
                value={values.shipmentItemQuantity || 0}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleOpenInventoryPlacement}
                        edge="end"
                        size="small"
                        sx={{ color: "primary.main" }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    cursor: "pointer",
                  },
                }}
                onClick={handleOpenInventoryPlacement}
              />
            </Grid>
            {project.shipmentItemUnitBreakdown && (
              <Grid size={12}>
                <TotalReceivingUnits name="totalPieces" label="Handling Units for This Item" />
              </Grid>
            )}
            {project.importedAssets && (
              <Grid size={12}>
                <Input name="itemNotes" label="Optional Item Notes" />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}
